import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import { columnTextField } from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import { formatDate } from "../constants";
import { listHistory } from "../services/franchise-marketing-api";

export default function DialogHistorico({ open, onClose, target }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open || !target) return;

    const load = async () => {
      setLoading(true);
      try {
        const entidade = target.ItemTipo === "Campanha" ? "Campanha" : "Conteudo";
        const history = await listHistory(entidade, target.Id);
        setItems(history);
      } catch (error) {
        console.error(error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [open, target]);

  const columnModel = [
    columnTextField({ dataField: "Acao", text: "Ação", align: "left" }),
    columnTextField({ dataField: "Descricao", text: "Descrição", align: "left" }),
    columnTextField({
      dataField: "NomeUsuario",
      text: "Usuário",
      align: "left",
    }),
    columnTextField({
      dataField: "DataAcao",
      text: "Data",
      align: "left",
      formatter: (_, row) => formatDate(row.DataAcao),
    }),
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>
        <Typography variant="h4" style={{ color: themeColorsDesingSystem.text.primary }}>
          Histórico — {target?.Titulo}
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Fechar"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <LoadingData searching label="Carregando histórico..." />
        ) : (
          <ToolkitTable
            keyField="Id"
            dataTable={items}
            columnModel={columnModel}
            notFoundTitle="Nenhum registro de histórico encontrado."
            pagination={{ options: [10, 25], defaultOption: 10, showTotal: true }}
          />
        )}
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={onClose} variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
